import C10CenterMessage from './versions/0.0.1';

// --------------- Add Widget to widgets/index.js as well
export default C10CenterMessage;
